import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import RewardRecord from './RewardRecord';
export default class PostRewards extends Component {
  view() {
    // @ts-ignore
    const rewards = this.attrs.post.moneyRewards();
    if (!Array.isArray(rewards) || rewards.length === 0) {
      return null;
    }
    return m('.PostMoneyRewards', [m('h4', app.translator.trans('clarkwinkelmann-money-rewards.forum.post.section')), m('ul.MoneyRewardRecords', rewards.map(reward => RewardRecord.component({
      reward
    })))]);
  }
}
flarum.reg.add('clarkwinkelmann-money-rewards', 'forum/components/PostRewards', PostRewards);